module.exports = __webpack_public_path__ + "img/9.34f6a1bf.jpg";